import React, { useState } from "react";
import { Modal, Typography, Box, Backdrop, Button, Paper } from "@mui/material";
import { API, graphqlOperation } from "aws-amplify";
import { deleteItemmaster, deletePartyMaster } from "../../graphql/mutations";
import { LoadingButton } from "@mui/lab";
import { showSuccessSnackbar, showWarningSnackbar } from "../snackBar/snakbar";
import { useThemes } from "../Theme/theme";
import { useDispatch, useSelector } from "react-redux";
import { deleteAccountMaster } from "../../graphql";
import { dashboardApi } from "../../redux/apis/dashboardApi";
import { listAccountMasterv2Api } from "../../redux/apis/accountMaster.api";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // bgcolor: 'background.paper',
  boxShadow: 24,
  outline: "none",
  borderRadius: "4px",
};

const DeleteParty = ({
  open,
  setOpen,
  partyData,
  rows,
  setRows,
  getPartyMasters,
  type,
  onDelete = () => { }
}) => {
  const { theme } = useThemes();
  const [loading, setloading] = useState(false);

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };
  let getCompany = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );
  const dispatch = useDispatch()
  async function deletePartyDet() {
    // console.log(data, "data");
    // const masterData = {
    //   partyid: data.partyid,
    //   // companyid: getCompany?.companyid,
    //   companybranchid: data.companybranchid,
    //   expiredtimestamp: Math.floor(new Date().getTime() / 1000),
    //   partytypecd: data.partytypecd,
    //   sameaddressflag: data.sameaddressflag,
    //   comments: data.comments,
    //   partydisplayname: data.partydisplayname,
    //   partylegalname: data.partylegalname,
    //   groupaccountid: data.groupaccountid,
    //   gstcategory: data.gstcategory,
    //   placeofsupply: data.placeofsupply,
    //   entity: data.entity,
    //   email: data.email,
    //   contactnumber: data.contactnumber,
    //   whatsappnumber: data.whatsappnumber,
    //   accountsid: data.accountsid,
    //   is_active: data.is_active === 0 ? 1 : 0,
    //   lastupdatedby: data?.lastupdatedby,
    //   deliveryconsigneename: data.deliveryconsigneename,
    //   deliveryconsigneegstin: data.deliveryconsigneegstin,

    //   udhyamregno: data.udhyamregno,
    //   msmetype: data.msmetype,
    //   tdspercentage: data.tdspercentage,
    //   financialyearid: getCompany?.relatedcompanydetailsnew[0]?.financialyearid,
    //   tdssection: data.tdssection,
    // };
    try {
      const res = await API.graphql(
        graphqlOperation(deleteAccountMaster, {
          accountsid: partyData.accountsid,
        })
      );
      if (res.data.deleteAccountMaster.statuscode == "Success") {
        dispatch(dashboardApi.util.invalidateTags(["dashboard"]))
        dispatch(listAccountMasterv2Api.util.invalidateTags(["listAccountMaster"]))
        const list = [...rows].filter(
          (party) => party.partyid !== partyData.id
        );
        setRows(list);
        showSuccessSnackbar(`${type} Deleted !`);
        onDelete()
      } else {
        // getPartyMasters(false, rows.length - 1, 1);
        let tempMsg = res.data.deleteAccountMaster.statusmessage;
        tempMsg = tempMsg.replace(/party/gi, type);
        showWarningSnackbar(tempMsg);
      }
      setloading(false);
      // console.log(res);
    } catch (error) {
      setloading(false);
      console.log(error);
    } finally {
      setOpen(false);
    }
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      {/* <Fade in={open}> */}
      <Paper sx={style}>
        <Box
          sx={{
            borderRadius: "4px",
            padding: "15px",
            textAlign: "center",
            overflowY: { xs: "scroll", sm: "hidden" },
            ".MuiTableCell-root": {
              padding: "10px 10px",
              fontSize: "13px",
            },
          }}
        >
          <Typography
            sx={{
              color: theme?.palette?.TmId.id.toString().includes("9")
                ? "white"
                : "rgb(60 60 60)",
              fontWeight: "bold",
            }}
          >
            Do you want to delete this {type}?
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            // flexDirection: { xs: 'column', sm: 'row' },
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "15px",
          }}
        >
          {/* <Button onClick={handleClose} variant='outlined' sx={{flex:1,margin:'5px', fontSize : "12px"}} >No</Button>
                        <Button color="error" onClick={deleteItem} variant='contained' sx={{flex:1,margin:'5px', fontSize : "12px"}} >Yes</Button>
                     */}

          <Button
            disabled={loading}
            onClick={handleClose}
            variant="outlined"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
          >
            No
          </Button>
          {/* <Button color="error" onClick={deleteItem} variant='contained' sx={{flex:1,margin:'5px', fontSize : "12px"}} >Yes</Button> */}
          <LoadingButton
            color="error"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
            loading={loading}
            disableRipple={true}
            variant="contained"
            onClick={deletePartyDet}
          >
            Yes
          </LoadingButton>
        </Box>
      </Paper>
      {/* </Fade> */}
    </Modal>
  );
};

export default DeleteParty;
